hiprintJQuery.fn.hiwprint = function(options) {
  var usedFrame = document.getElementById("hiwprint_iframe");
  if (usedFrame) usedFrame.parentNode.removeChild(usedFrame);
  var opt = hiprintJQuery.extend({}, hiprintJQuery.fn.hiwprint.defaults, options);
  var $element = this;
  var $iframe = hiprintJQuery(
    '<iframe id="hiwprint_iframe"  style="visibility: hidden; height: 0; width: 0; position: absolute;"></iframe>'
  );
  var css = "";
  if (opt.importCss) {
    if (opt.styleHandler) {
      css += opt.styleHandler();
    }
    if (hiprintJQuery("link[media=print]").length > 0) {
      hiprintJQuery("link[media=print]").each(function() {
        if (hiprintJQuery(this).attr("href").indexOf("print-lock.css") >= 0) {
          css += '<link rel="stylesheet" type="text/css" media="print" href="' + hiprintJQuery(this).attr("href") + '">';
          css += '<link rel="stylesheet" type="text/css" href="' + hiprintJQuery(this).attr("href") + '">';
        }
      });
    }
  }
  $iframe[0].srcdoc = '<!DOCTYPE html><html><head><title></title><meta charset="UTF-8">' + css + "</head><body></body></html>";
  $iframe[0].onload = function() {
    var printDocument = $iframe[0].contentWindow || $iframe[0].contentDocument;
    if (printDocument.document) printDocument = printDocument.document;
    if (!$iframe.attr("srcdoc")) {
      printDocument.write(
        '<!DOCTYPE html><html><head><title></title><meta charset="UTF-8">' + css + "</head><body></body></html>"
      );
    }
    if (opt.printContainer) {
      printDocument.body.innerHTML = $element[0].outerHTML;
    } else {
      printDocument.body.innerHTML = $element.html();
    }
    loadAllImages(printDocument, function() {
      performPrint($iframe[0], opt);
    });
  };
  $iframe.appendTo("body");
};
hiprintJQuery.fn.hiwprint.defaults = {
  importCss: true,
  printContainer: true,
  callback: null,
  styleHandler: null
};
function performPrint(iframeElement, opt) {
  try {
    iframeElement.focus();
    if (isEdge() || isIE()) {
      try {
        iframeElement.contentWindow.document.execCommand("print", false, null);
      } catch (e) {
        iframeElement.contentWindow.print();
      }
    } else {
      iframeElement.contentWindow.print();
    }
    if (opt.callback) {
      opt.callback();
    }
  } catch (error) {
    /* @__PURE__ */ console.log(error);
  }
}
function isIE() {
  return navigator.userAgent.indexOf("MSIE") !== -1 || !!document.documentMode;
}
function isEdge() {
  return !isIE() && !!window.StyleMedia;
}
function loadAllImages(printDocument, callback, time) {
  if (time === void 0) {
    time = 0;
  }
  var images = printDocument.getElementsByTagName("img");
  var allLoaded = true;
  for (var i = 0; i < images.length; i++) {
    var image = images[i];
    if (image.src && image.src !== window.location.href && image.src.indexOf("base64") == -1) {
      if (!image || typeof image.naturalWidth === "undefined" || image.naturalWidth === 0 || !image.complete) {
        if (!image.complete) {
          allLoaded = false;
        }
      }
    }
  }
  time++;
  if (!allLoaded && time < 10) {
    setTimeout(function() {
      loadAllImages(printDocument, callback, time);
    }, 500);
  } else {
    callback();
  }
}
